// Encode applied `key:value` tag pairs into the single `tags` query param.
// Each pair is percent-encoded before joining so a comma inside a tag value
// (a free-form string) becomes %2C and never collides with the comma delimiter
// separating pairs. decodeTagsParam is the exact inverse.
export function encodeTagsParam(pairs: string[]): string {
  return pairs.map((pair) => encodeURIComponent(pair)).join(',')
}
